import request from '@/util/request'
import {
  JSON_CONFIG
} from '@/util/helper.js'

export function getKSQList (patientId) {
  return request({
    url: `/patient/${patientId}/ksq`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function getKSQDetail (patientId, ksqId) {
  return request({
    url: `/patient/${patientId}/ksq/${ksqId}`,
    method: 'get',
    header: JSON_CONFIG
  })
}



// WEBPACK FOOTER //
// ./src/api/patient/ksq.js